import { apiFetch } from '../fetchApi'

export const fetchStatusReport = async (BeURL, showAlert, filters, setReportData, setLoading, key) => {

    try {
        setLoading(prev => ({
            ...prev,
            [key]: true
        }))
        const res = await apiFetch(`${BeURL}/statusOverall-report`, {
            method: "POST",
            body: JSON.stringify(filters)
        })
        const data = await res.json()

        if (data.success) {
            console.log("Status report data:", data);
            setReportData(prev => {
                let tempReportData = { ...prev }
                const statusData = data.eachStatuses || []
                // data: [
                //     {
                //         "x-axis": [],
                //         "y-axis": []
                //     }
                // ],
                if (statusData?.length) {
                    const x = statusData.map(item => item.status || "Unknown");
                    const y = statusData.map(item => item.count || 0);
                    const formattedData = [{
                        "x-axis": x,
                        "y-axis": y

                    }]
                    tempReportData["status"].data = formattedData
                }
                tempReportData["status"].totalCount = data.totalStatusReport || 0
                return tempReportData
            })
        }
        else {
            showAlert(data.message)
        }
    }

    catch (err) {
        console.log("Error fetching Status report:", err);
        showAlert("Trouble in connecting to the server!")
    }
    finally {
        setLoading(prev => ({
            ...prev,
            [key]: false
        }))
    }
}